import { useSelector } from "react-redux"
import styled from "styled-components"
import Btn from "../../shared/button/Btn"
import { useDispatch } from "react-redux"
import { showModal } from "../../../features/modal/modalSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: auto;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
          margin: 40px;
          width: auto;
          height: auto;
          max-height: 600px;

          .iframe{
            width: 850px;
            height: 600px;
          }

        }

        .btn-container{
          display: flex;
          margin: 40px 0;

        }
    }
`

const GibFaturaDetailHtmlModal = () => {

  const {viewEArsivInvoiceData} = useSelector(state => state.eArsiv)
  const dispatch = useDispatch()

  return (
    <Container>
      <div className="modal">
        <div className="content">
          <iframe srcDoc={viewEArsivInvoiceData} frameborder="0" className="iframe">
          </iframe>
        </div>
        <div className="btn-container">
          <Btn bgColor="#E85446" color="#fff" width={"220px"} handleClick={() => dispatch(showModal(null))}>Kapat</Btn>
        </div>
      </div>
    </Container>
  )
}

export default GibFaturaDetailHtmlModal